import config from '../config.js';
import AWS from 'aws-sdk';

export async function invokeApig(
  { path,
    method = 'GET',
    body }, userToken) {

  const url = `${config.apiGateway.URL}${path}`;
  const headers = {
    Authorization: userToken,
  };

  body = (body) ? JSON.stringify(body) : body;

  const results = await fetch(url, {
    method,
    body,
    headers
  });

  if (results.status !== 200) {
    throw new Error(await results.text());
  }

  return results.json();
}


export function getAwsCredentials(userToken) {
  const authenticator = `cognito-idp.${config.cognito.REGION}.amazonaws.com/${config.cognito.USER_POOL_ID}`;

  AWS.config.update({ region: config.cognito.REGION });

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
    Logins: {
      [authenticator]: userToken
    }
  });

  return AWS.config.credentials.getPromise();
}


/*
// use this to resize the file and upload it to S3
resizeFile(fileType, fileName) {

  // first put file into a canvas

  var canvas = document.createElement("canvas");
  canvas.height = 600;
  canvas.width = 800;
  var ctx = canvas.getContext();

  //var canvas  = document.getElementById("imagePreviewChatFooter");
  var dataUrl = canvas.toDataURL("image/jpeg");
  var blobData = dataURItoBlob(dataUrl);
  var fileName = file.name;
  var params = {Key: fileName, ContentType: file.type, Body: blobData};
  bucket.upload(params, function (err, data) {
      console.log(data);
      console.log(err ? 'ERROR!' : 'UPLOADED.');
  });

  return file
  // file consists of: file, file.type, file.name

}
*/


//////////// upload urlencoed base64 image file to s3 //////////
/*

  // this one uses S3. putObject
  buf = new Buffer(req.body.imageBinary.replace(/^data:image\/\w+;base64,/, ""),'base64')
  var data = {
    Key: req.body.userId,
    Body: buf,
    ContentEncoding: 'base64',
    ContentType: 'image/jpeg'
  };
  s3Bucket.putObject(data, function(err, data){
      if (err) {
        console.log(err);
        console.log('Error uploading data: ', data);
      } else {
        console.log('succesfully uploaded the image!');
      }
  });

*/


/*

// also for base64 encoded image. // no AJAX needed, as things are done with AWS SDK directly..
// is that wise?
exports.saveImage = function (req, res) {

  var imageExtension = imageBody.split(';')[0].split('/');
  imageExtension = imageExtension[imageExtension.length - 1];

  buf = new Buffer(req.body.imageBody.replace(/^data:image\/\w+;base64,/, ""), 'base64');


  // bucketName var below crates a "folder" for each user
  var bucketName = 'myApp/' + req.body.userEmail;
  var params = {
      Bucket: bucketName
    , Key: req.body.imageName
    , Body: buf
    , ContentType: 'image/' + req.body.imageExtension
    , ACL: 'public-read'
  };

  s3.upload(params, function (err, data) {
    if (err) return res.status(500).send(err);

    // TODO: save data to mongo
    res.json(data);
  });
}
*/


/*
//upload file to s3 with progress bar:
// more on the topic: http://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3/ManagedUpload.html

if (file) {
  var params = {Key: 'FILE_NAME', ContentType: file.type, Body: file};
  bucket.upload(params).on('httpUploadProgress', function(evt) {
    console.log("Uploaded :: " + parseInt((evt.loaded * 100) / evt.total)+'%');
  }).send(function(err, data) {
    alert("File uploaded successfully.");
  });
}
*/


/*
// another upload progress:
var request = s3.putObject(params);
request.on('httpUploadProgress', function (progress) {
  console.log(progress.loaded + " of " + progress.total + " bytes");
});
request.send();
*/

/////////////////////////////////

// aws .upload can do multi-part upload, .putObject can not

export async function s3Upload(file, userToken) {
  await getAwsCredentials(userToken);

  const s3 = new AWS.S3({
    params: {
      Bucket: config.s3.BUCKET,
    }
  });
  const filename = `${AWS.config.credentials.identityId}-${Date.now()}-${file.name}`;

  return s3.upload({
    Key: filename,
    Body: file,
    ContentType: file.type,
    ACL: 'public-read',
  }).promise();
}



// WEBPACK FOOTER //
// ./src/libs/awsLib.js